import { IStaffer } from '@principle-theorem/principle-core/interfaces';
import {
  asyncForEach,
  Firestore,
  snapshot,
  WithRef,
} from '@principle-theorem/shared';
import { Staffer } from '../models/staffer/staffer';

export class RevokeAccessFromDisabledStaff {
  async run(allStaff: WithRef<IStaffer>[]): Promise<void> {
    const allUsers = await asyncForEach(allStaff, (staffer) =>
      snapshot(Staffer.user$(staffer))
    );

    const disabledUsersWithAccess = allUsers.filter(
      (user) =>
        !user.isEnabled && (!!user.practices.length || !!user.brands.length)
    );

    await asyncForEach(disabledUsersWithAccess, (user) =>
      Firestore.patchDoc(user.ref, {
        brands: [],
        practices: [],
      })
    );
  }
}
